import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
// components
import { Row } from "react-bootstrap";
import { BsFillPlusCircleFill } from "react-icons/bs";

import SearchBar from "../../../components/SearchBar";
import ProtectedAccess  from '../../../components/ProtectedAccess'
//page
import BookItem from "./BookItem";

import TextLoader from '../../../components/TextLoader/TextLoader';
import CustomPagination from '../../../components/CustomPagination';
import { getSortedBooks } from '../../../api/books';

import Dialog from "../create/CreateBookDialog";

// const BOOKS_PER_PAGE = 10; // TODO: add to admin settings 

const BookGallery = (props) => {

  const { lang, query, setQuery  } =  props;

  const BOOKS_PER_PAGE = 15; // TODO: add to admin settings 
  
  const [loading, setLoading] = useState(true);
  const [books, setBooks] = useState([]);
  const [step, setStep] = useState(1);
  const [pages, setPages] = useState(1);
  const [show, setShow] = useState(false);
  const [current, setCurrent] = useState(null);

  // const [viewer, setViewer]= useState(false);
  const params = useParams()
  const history = useNavigate()
  const { field, order } = params;

  // const { searchText } = useParams();

  const handleClose = () => {
    setCurrent(null)
    setShow(false)
    fetchBooks()
  };

  const handleShow = (user) =>{
    setCurrent(user)
    setShow(true)
  };

  const fetchBooks = async () => {
    let BooksRaw = [];
    // setViewer(false);
    if (query){
      setLoading(true);
      history("/editorial/books")
    }else{
      const {data:{docs, pages}} = await getSortedBooks(field, order)
          .catch(function (error) {
            setLoading(false);
            // if (code === 401) {return setNotShared(message)}
            return {data:[]};
          })
      BooksRaw = docs;
      const numberOfPages = pages //Math.ceil(BooksRaw.length / AUTHORS_PER_PAGE);
      setPages(numberOfPages);
    }
    setBooks(BooksRaw);
    setLoading(false);
  }

  useEffect(() => {
      fetchBooks();
  }, [field, order, query])

  useEffect(() => {
    if(query !== ""){fetchBooks();}
  }, [query])

  const nextFetchBooks = async (step) => {
    if (query){

    }else{
      const {data:{docs, pages}} = await getSortedBooks(BOOKS_PER_PAGE,step)
      .catch(function (error) {
        setLoading(false);
        return {data:[]};
      })
      setBooks(books.concat(docs));
    }
  }

  const paginateBooks = () => {
    let booksToDisplay = [];
    for (let i = (step - 1) * BOOKS_PER_PAGE; i < Math.min(step * BOOKS_PER_PAGE, books.length); i++) {
      const item = books[i];
      booksToDisplay.push(
        <BookItem 
          key={item._id}
          id={item.isbn13}
          book={item} 
          BOOKS_PER_PAGE={BOOKS_PER_PAGE} 
          handleShow={()=>handleShow(item)}
          lang={lang} />
      )
    }
    return booksToDisplay
  }

  const displayBooks = () => {
    return (
      <>
        <ProtectedAccess 
          element={
            <div>
              <button 
                className="btn btn-primary"
                style={{ margin:'10px 0px', width:'100%' }}
                onClick={()=>handleShow(null)} >
                  <BsFillPlusCircleFill size={20}/> Agregar al catalogo
              </button>
            </div>
          }
          role={['admin', 'editor']}
          lang={lang}
        />
        <div className="gallery" style={{ display:'flex', flexWrap:'wrap' }}>
            <Dialog
              show={show} 
              handleClose={handleClose}
              lang={lang}
              current={current}
            />            
            {paginateBooks()}
        </div >
        <Row className='justify-content-md-center'>
            <CustomPagination 
              step={step} 
              setStep={setStep} 
              pages={pages} 
              pagesToShow={13}
              fetchData={nextFetchBooks} />
          </Row>
      </>
    )
  }

  const showGalleryBooks = () => {
    if (loading) {
      return (
        <Row className=''>
          <div style={{ paddingTop: '40px' }} />
          <TextLoader
            upperMessage={lang.book.loading.books_upper}
            lowerMessage={lang.book.loading.books_lower}
          />
        </Row>
      )
    }

    // TODO retornar un componente especial cuando no existan libros para mostrar.
    if (books && books.length === 0) {
      return (
        <>
          <Row className='justify-content-md-center'>
            <div style={{ paddingTop: '40px' }} />
            <TextLoader
              upperMessage={'No se han obtenido libros.'} //lang.author.loading.books_upper}
              lowerMessage={''} //lang.author.loading.books_lower}
            />
          </Row>
        </>
      )
    }

    return displayBooks();
  }

  return (
    <>
      <SearchBar 
        searchItem={ setQuery }
        query={query}
        setQuery={setQuery}
        placeholder={lang.book.title}
      />
      <Row className=''>
        {showGalleryBooks()}
      </Row>
    </>
  );
};

export default BookGallery;
